var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    { staticClass: "cd-sidebar-buttons mt-2" },
    [
      _vm.currentProgress === 7
        ? _c(
            "b-button",
            {
              staticClass: "btn cd-button cd-std-button cd-next-button",
              on: {
                click: function($event) {
                  return _vm.navigateToOffer()
                }
              }
            },
            [_vm._v("weiter zur Angebotsanfrage")]
          )
        : _vm._e(),
      _vm.currentProgress === 8
        ? _c(
            "b-button",
            {
              class: _vm.submitButtonClasses,
              on: {
                click: function($event) {
                  return _vm.submitContactForm()
                }
              }
            },
            [
              _vm._v(
                _vm._s(
                  _vm.offerSubmitted ? "Angebot angefragt!" : "Angebot anfragen"
                )
              )
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }